<ng-template #inventoryAssetModalForm role="document" let-modal>

  <app-modal-comp-header
    [title]="'Asset ' + assetId"
    (cancelButtonOnClick)="cancelForm()"
  ></app-modal-comp-header>

  <div class="modal-body">

    @if (isLoading) {
      <div class="text-center text-muted py-5">
        <div class="spinner-border text-success mb-2" role="status"></div>
        <div>Loading asset details...</div>
      </div>
    }
    @else if (loadError) {
      <div class="alert alert-danger mb-0" role="alert">{{ loadError }}</div>
    }
    @else {
      <!-- Status -->
      <div class="d-flex flex-wrap align-items-center gap-3 p-3 mb-3 rounded border-start border-4 bg-{{ statusColour(device.status) }}-subtle border-{{ statusColour(device.status) }}">
        <i class="{{ statusIcon(device.status) }} fs-3 text-{{ statusColour(device.status) }}"></i>
        <div class="flex-grow-1">
          <div class="fw-semibold text-{{ statusColour(device.status) }}">{{ statusLabel(device.status) }}</div>
          @if (device.assignedTo) {
            <div class="fw-medium">{{ device.assignedTo }}</div>
          }
        </div>
        <div class="text-muted small text-end">
          <div>{{ display(device.make) }} {{ device.model ?? '' }}</div>
          <div>Purchased {{ formatDate(device.purchaseDate) }}</div>
        </div>
      </div>

      <div class="row g-3">
        <!-- Asset Identification -->
        <div class="col-lg-6">
          <div class="card mb-0 h-100">
            <div class="card-header py-2"><h6 class="card-title mb-0">Asset Identification</h6></div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-6">
                  <div class="text-muted small text-uppercase">Asset ID</div>
                  <div class="fw-medium font-monospace">{{ display(device.assetId) }}</div>
                </div>
                <div class="col-6">
                  <div class="text-muted small text-uppercase">Serial Number</div>
                  <div class="fw-medium font-monospace">{{ display(device.serialNumber) }}</div>
                </div>
                <div class="col-6">
                  <div class="text-muted small text-uppercase">Purchase Date</div>
                  <div class="fw-medium">{{ formatDate(device.purchaseDate) }}</div>
                </div>
                <div class="col-6">
                  <div class="text-muted small text-uppercase">Warranty Expiry</div>
                  <div class="fw-medium">{{ formatDate(device.warrantyExpiry) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Network Details -->
        <div class="col-lg-6">
          <div class="card mb-0 h-100">
            <div class="card-header py-2"><h6 class="card-title mb-0">Network Details</h6></div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-6">
                  <div class="text-muted small text-uppercase">IMEI</div>
                  <div class="fw-medium font-monospace">{{ display(device.imei) }}</div>
                </div>
                <div class="col-6">
                  <div class="text-muted small text-uppercase">Phone Number</div>
                  <div class="fw-medium font-monospace">{{ display(device.phoneNumber) }}</div>
                </div>
                <div class="col-12">
                  <div class="text-muted small text-uppercase">SIM Number</div>
                  <div class="fw-medium font-monospace">{{ display(device.simNumber) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Device Details -->
        <div class="col-12">
          <div class="card mb-0">
            <div class="card-header py-2"><h6 class="card-title mb-0">Device Details</h6></div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-4">
                  <div class="text-muted small text-uppercase">Make</div>
                  <div class="fw-medium">{{ display(device.make) }}</div>
                </div>
                <div class="col-md-4">
                  <div class="text-muted small text-uppercase">Model</div>
                  <div class="fw-medium">{{ display(device.model) }}</div>
                </div>
                <div class="col-md-4">
                  <div class="text-muted small text-uppercase">Distributor</div>
                  <div class="fw-medium">{{ display(device.distributor) }}</div>
                </div>
                <div class="col-12">
                  <div class="text-muted small text-uppercase">Notes</div>
                  <div class="inventory-notes">{{ display(device.notes) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="modal-footer">
    <div class="hstack gap-2 justify-content-end">
      <button class="btn btn-light" type="button" (click)="cancelForm()">Close</button>
    </div>
  </div>

</ng-template>
